import React from 'react';
import { H3, H5, Text } from 'atoms';
import { Fade } from "react-awesome-reveal";
import { Image } from 'react-datocms';

interface Props {
    gallery: any;
    bgColor?: string;
    heading?: string;
    padding?: string;
}

export const ThreeBlockGrid = ({ gallery, bgColor, heading, padding }: Props) => (
    <div className='tgb' style={padding && { padding }}>
        <Fade>
            <div className='tgb__content'>
                <div>
                    <H3 style={{ color: '#121651', textAlign: 'center' }} mb={8}>
                        {heading ? heading : 'Muzology Teaches Math in Minutes. Here’s How!'}
                    </H3>
                    <div className='grid'>
                        {gallery.map((block) => (
                            <div key={block?.title}>
                                <Image className='img-container' data={{ ...block.responsiveImage, bgColor: '#ffffff00' }} />

                                {/*
                    <div className='img-container'>
                      <img src={block.url} />
                    </div>
                    */}
                                <H5 style={{ textAlign: 'center', color: '#121651' }} mb={4} mt={2}>
                                    {block?.title}
                                </H5>
                                <Text
                                    style={{
                                        color: '#4f4f4f',
                                        fontWeight: 500,
                                        fontSize: '18px'
                                    }}
                                >
                                    {block.customData.description}
                                </Text>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Fade>
        <style jsx>{`
            .tgb {
                width: 100%;
                padding: 48px 60px;
                background-image: url('/assets/backgrounds/hp-tg.svg');
                background-size: cover;
                background-position: center;
                background-color: ${bgColor || '#fff'};
            }

            .tgb__content {
                display: flex;
                align-items: center;
                justify-content: center;
                max-width: 1100px;
                margin: 0 auto;
            }

            .grid {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                grid-gap: 16px;

                > div {
                    margin: 16px 0;
                    padding: 8px;

                    img {
                        max-width: 280px;
                        width: 100%;
                        margin: 0 auto;
                        display: block;
                    }
                }
            }

            @media (max-width: 992px) {
                .tgb {
                    padding: 48px 40px;
                    background-image: none;
                }

                .grid {
                    grid-template-columns: 1fr;

                    > div {
                        max-width: 680px;
                        margin: 0 auto;
                    }

                    img {
                        display: block;
                        margin: 0 auto;
                    }
                }
            }

            @media (max-width: 480px) {
                .tgb {
                    padding: 48px 20px 30px;
                }
            }
        `}</style>
    </div>
);
